import React, { useCallback, useState } from "react";
import YandexMap from "./map/YandexMap";
import { Button, ButtonGroup } from "@blueprintjs/core";
import StylesDialog from "./controls/StylesDialog";

function App() {
  const [isStylesOpened, setStylesOpened] = useState(false);
  return (
    <div>
      <YandexMap />
      <div
        style={{
          position: "absolute",
          zIndex: 200,
          top: 0,
          right: 0,
          margin: "10px",
          float: "right",
        }}
      >
        <ButtonGroup>
          <Button icon="style" onClick={() => setStylesOpened(true)}>
            Настройки
          </Button>
        </ButtonGroup>
      </div>
      <StylesDialog
        isOpen={isStylesOpened}
        onClose={() => setStylesOpened(false)}
      />
      <div
        style={{
          position: "absolute",
          zIndex: 200,
          bottom: 20,
          right: 0,
          margin: "10px",
          width: "190px",
          fontSize: "6pt",
          float: "bottom",
        }}
      >
        Веб-сервис разработан за счет гранта Российского научного фонда №
        22-11-20015, проводимого совместно с органами власти Республики Карелия
        с финансированием из Фонда венчурных инвестиций Республики Карелия (ФВИ
        РК).
      </div>
    </div>
  );
}

export default App;
